import React, { createContext, useContext, useEffect, useState } from 'react';
import { isAuthenticated, getProfile } from '../services/auth';
import { api } from '../services/api';

const AppContext = createContext();

export function AppProvider({ children }) {
    const [authed, setAuthed] = useState(isAuthenticated());
    const [profile, setProfile] = useState(null);
    // Dispositivo selecionado para configurar/comandar (até 10 placas)
    const [selectedDeviceId, setSelectedDeviceId] = useState(
        localStorage.getItem('ag_device') || 'esp32_001'
    );
    const [devices, setDevices] = useState([]);

    // Mantém a lista disponível também na landing, para decidir se a conta
    // possui uma controladora configurada antes de entrar na central.
    useEffect(() => {
        if (!authed) {
            setDevices([]);
            return;
        }
        api.get('/devices')
            .then(res => setDevices(res.data.devices || []))
            .catch(() => setDevices([]));
    }, [authed]);

    const selectDevice = (id) => {
        localStorage.setItem('ag_device', id);
        setSelectedDeviceId(id);
    };

    const login = () => {
        setAuthed(true);
        // Carrega o perfil da conta recém-autenticada
        getProfile().then(res => setProfile(res.user)).catch(() => {});
    };

    const logout = () => {
        localStorage.removeItem('ag_token');
        setAuthed(false);
        setProfile(null);
    };

    const value = {
        authed,
        setAuthed,
        profile,
        setProfile,
        login,
        logout,
        selectedDeviceId,
        setSelectedDeviceId: selectDevice,
        devices,
        setDevices
    };

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
    return useContext(AppContext);
}
